import { RestMethod } from "../../_helpers/ApiConfig/RestMethod";
import { USER_DATA_CONSTANT } from "app/_constants/Redux/userData.constant";
import configureStore from "../../redux/Store";
let { Store } = configureStore();
export async function getAllSites(filter) {
  let url = "/global-configuration/ehs-module/all-sites?";
  if (filter) url += filter;
  try {
    const siteData = Store.getState()?.userManagement?.site;
    if ((Array.isArray(siteData) && siteData.length === 0) || filter) {
      const response = await RestMethod.GET(url);
      if (response.data.status && !filter)
        Store.dispatch({
          type: USER_DATA_CONSTANT.SITE,
          data: response,
        });
      return response.data;
    } else {
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({
            status: 1,
            message: "Data from store",
            data: siteData,
          });
        }, 0);
      });
    }
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllSitesWithAccess(filter) {
  let url = "/global-configuration/ehs-module/available-site?";
  const availableSitesData = Store.getState()?.userManagement?.availableSites;
  if (!filter && availableSitesData.data) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          status: 1,
          message: "Data from store",
          data: availableSitesData.data,
        });
      }, 0);
    });
  }
  if (filter) url += filter;

  try {
    const response = await RestMethod.GET(url);
    if (!filter && response.data.status) {
      Store.dispatch({
        type: USER_DATA_CONSTANT.AVAILABLE_SITES,
        data: response.data.data,
      });
    }
    console.log("api response", response.data);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function createSite(data) {
  try {
    const response = await RestMethod.POST(
      "/global-configuration/ehs-module/create-site",
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function updateSite(id, data) {
  try {
    const response = await RestMethod.PUT(
      "/global-configuration/ehs-module/update-site/" + id,
      data
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function deleteSite(id) {
  try {
    const response = await RestMethod.DELETE(
      "/global-configuration/ehs-module/delete-site/" + id
    );
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}

export async function getAllSitesData(filter) {
  let url = "/global-configuration/ehs-module/all-sites-data";
  if (filter) url += `?${filter}`;
  try {
    const response = await RestMethod.GET(url);
    return response.data;
  } catch (error) {
    console.log("error detected while fetching data from api");
    return null;
  }
}
